import React, { FunctionComponent } from "react";

import { contentManagementLinks } from "./data";
import { NavLinkComponent } from "./NavLink";

export const ContentManagementLinks: FunctionComponent = () => (
  <>
    {contentManagementLinks.map((link) => (
      <NavLinkComponent key={link.name} name={link.name} path={link.path}>
        <link.Icon />
      </NavLinkComponent>
    ))}
  </>
);
